'use client'

import React, { FC, ReactElement } from 'react'
import WarningModal from '@/components/warning-modal'
import useSatoshiPrice from '@/utils/hooks/useSatoshiPrice'
import { NETWORK } from '@/utils/constants'

const InscriptionWarningBelowFloor: FC<{
	open: boolean
	onCancel: () => void
	onConfirm: () => void
	bitcoinAmount: string
	floorPriceSats: number
}> = (props): ReactElement => {
	const { onCancel, onConfirm, bitcoinAmount, floorPriceSats } = props
	const floorPrice = useSatoshiPrice(floorPriceSats)

	return (
		<WarningModal
			open={props.open}
			onClose={onCancel}
			title="Below floor alert!"
			description={
				<p>
					The floor for this collection is {floorPrice} {NETWORK}. Your listing for {bitcoinAmount} {NETWORK} is
					below floor price!
				</p>
			}
			confirmLabel="I still want to list"
			cancelLabel="Cancel listing"
			onConfirm={onConfirm}
			onCancel={onCancel}
			buttonDisplay="default-epic"
		></WarningModal>
	)
}

export default InscriptionWarningBelowFloor
